import React from 'react';
import { AlternativeProjectResource } from 'src/helpers/api/alternativeProjects';
import RelatedStory from './RelatedStory';
import { getImageUrlWithTemplate } from 'src/helpers/image';
import currencyMap from 'src/helpers/currencyMap';
import styles from './AlternativeProjects.scss';
import { AlternativeProjectEventData } from 'src/redux/modules/alternativeProjects';
import defaultAvatar from '../../../static/images/default-avatar.svg';
import { FormattedMessage } from 'react-intl';

const MAX_ALTERNATIVE_PROJECTS = 3;

interface Props {
  alternativeProjects: {
    items: AlternativeProjectResource[];
  };
  avatars: { [key: string]: string };
  loadAvatars: (userIds: string[]) => void;
  renderAlternativeProjectCard: (data: AlternativeProjectEventData) => void;
  clickOnAlternativeProjectCard: (data: AlternativeProjectEventData) => void;
}

const mapProjectToAnalyticsSpec = (
  project: AlternativeProjectResource,
  cardRank: number
) => ({
  projectId: project.projectId,
  cardCount: MAX_ALTERNATIVE_PROJECTS,
  cardUrl: project.projectUrl,
  cardRank,
});

class AlternativeProjects extends React.Component<Props> {
  componentDidMount() {
    const { alternativeProjects, loadAvatars } = this.props;

    if (__CLIENT__ && alternativeProjects.items) {
      loadAvatars(alternativeProjects.items.map(p => p.ownerId));
    }
  }

  render() {
    const {
      alternativeProjects,
      avatars,
      renderAlternativeProjectCard,
      clickOnAlternativeProjectCard,
    } = this.props;

    if (!alternativeProjects || alternativeProjects.items.length === 0) {
      return null;
    }

    const firstThreeAlternativeProjects = alternativeProjects.items.slice(
      0,
      MAX_ALTERNATIVE_PROJECTS
    );

    return (
      <div className="jg-bdt jg-bd--very-light-grey">
        <div className={styles.container}>
          <h2 className="jg-h2 jg-space-mvmd jg-space-mvlg@lg jg-space-plsm@lg">
            <FormattedMessage
              id="AlternativeProjects.storiesLikeThisHeading"
              defaultMessage="Crowdfunding stories like this"
            />
          </h2>
          <ul className={styles['stories-list']}>
            {firstThreeAlternativeProjects.map((project, index) => {
              const {
                amountRaised,
                progress,
                pitch,
                owner,
                ownerId,
                numberOfSupporters,
                projectImage,
                projectId,
                projectUrl,
                targetCurrency,
              } = project;

              const analyticSpec = mapProjectToAnalyticsSpec(
                project,
                index + 1
              );

              return (
                <li className={styles.story} key={projectId}>
                  <RelatedStory
                    percentage={progress || 0}
                    title={pitch}
                    owner={owner}
                    numberOfSupporters={numberOfSupporters}
                    totalRaised={
                      new Intl.NumberFormat([], {
                        maximumFractionDigits: 0,
                      }).format(amountRaised) || 0
                    }
                    ownerAvatar={
                      getImageUrlWithTemplate(
                        avatars[ownerId],
                        'CrowdfundingSupporterAvatar'
                      ) || defaultAvatar
                    }
                    pageImage={getImageUrlWithTemplate(
                      projectImage.url,
                      'DiscoverCard'
                    )}
                    currencySymbol={currencyMap[targetCurrency] || '£'}
                    onClick={() => {
                      clickOnAlternativeProjectCard(analyticSpec);
                    }}
                    pageLink={projectUrl}
                    id={projectId}
                    componentDidMountCallback={() => {
                      renderAlternativeProjectCard(analyticSpec);
                    }}
                  />
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    );
  }
}

export default AlternativeProjects;



// WEBPACK FOOTER //
// ./src/components/AlternativeProjects/AlternativeProjects.tsx